export default __webpack_public_path__ + "static/media/ethereum.a18642a2.png";